// ===================================================== ===================================================== SECTION 1
const coSwiper1 = new Swiper('.co-s1-slider', {
  effect: "fade",
  slidesPerView: "auto",
  speed: 400,
  preventInteractionOnTransition: true,
  allowTouchMove: false,
  fadeEffect: {
    crossFade: true,
  },
  loop: true,
  pagination: {
    el: '.co-home-s1 .swiper-pagination',
    type: 'bullets',
    clickable: true,
  },
  autoplay: {
    delay: 4000,
    disableOnInteraction: false,
  },
});
// ===================================================== ===================================================== SECTION 2
// ===================================================== TABS
const thumbnails = document.querySelectorAll('.co-home-s2-thumbnail-item');
const collections = document.querySelectorAll('.co-home-s2-collection');
if (thumbnails.length > 0) {
  thumbnails[0].classList.add('co-active');
  const firstCollectionId = thumbnails[0].getAttribute('data-collection-id');
  const firstCollection = document.getElementById(firstCollectionId);
  if (firstCollection) {
    firstCollection.classList.remove('co-hidden');
    firstCollection.classList.add('co-active');
  }
}
thumbnails.forEach(function(thumbnail) {
  thumbnail.addEventListener('click', function() {
    if (thumbnail.classList.contains('co-active')) {
      return; 
    }
    thumbnails.forEach(function(th) {
      th.classList.remove('co-active');
    });
    thumbnail.classList.add('co-active');
    collections.forEach(function(collection) {
      collection.classList.remove('co-active');
      collection.classList.add('co-hidden');
    });
    const collectionId = thumbnail.getAttribute('data-collection-id');
    const selectedCollection = document.getElementById(collectionId);
    selectedCollection.classList.remove('co-hidden');
    selectedCollection.classList.add('co-active');
  });
});
// ===================================================== SLIDER
document.querySelectorAll('.co-home-s2-collection').forEach((collection) => {
  const slider = collection.querySelector('.co-home-s2-collection-slider');
  const scrollbar = collection.querySelector('.swiper-scrollbar');
  const prevButton = collection.querySelector('.swiper-button-prev');
  const nextButton = collection.querySelector('.swiper-button-next');
  const swiper = new Swiper(slider, {
    slidesPerView: "auto",
    freeMode: true,
    navigation: {
      nextEl: nextButton,
      prevEl: prevButton
    },
    scrollbar: {
      el: scrollbar,
      draggable: true,
    },
    mousewheel: {
      forceToAxis: true,
    },
    breakpoints: {
      0: {
        slidesOffsetBefore: 20,
        slidesOffsetAfter: 20,
        spaceBetween: 10,
      },
      768: {
        slidesOffsetBefore: 30,
        slidesOffsetAfter: 30,
        spaceBetween: "1%",
      },
      990: {
        slidesOffsetBefore: 40,
        slidesOffsetAfter: 40,
        spaceBetween: "1%",
      },
    },
  });
  function getSlidesToMove() {
    return window.innerWidth < 768 ? 1 : 3;
  }
  nextButton.addEventListener('click', (e) => {
    e.preventDefault();
    e.stopPropagation();
    swiper.slideTo(swiper.activeIndex + getSlidesToMove());
  });
  prevButton.addEventListener('click', (e) => {
    e.preventDefault();
    e.stopPropagation();
    swiper.slideTo(swiper.activeIndex - getSlidesToMove());
  });
});
// ===================================================== ===================================================== SECTION 3
const coSwiper3_1 = new Swiper('.co-home-s3-slider-1', {
  effect: "fade",
  slidesPerView: 1,
  speed: 400,
  preventInteractionOnTransition: true,
  allowTouchMove: false,
  updateOnSlideChange: true,
  fadeEffect: {
    crossFade: true,
  },
  navigation: {
      nextEl: '.co-home-s3 .swiper-button-next',
      prevEl: '.co-home-s3 .swiper-button-prev'
    },
  // autoplay: {
  //   delay: 4000,
  //   disableOnInteraction: false,
  // },
});
const coSwiper3_2 = new Swiper('.co-home-s3-slider-2', {
  effect: "fade",
  slidesPerView: 1,
  speed: 400,
  preventInteractionOnTransition: true,
  allowTouchMove: false,
  updateOnSlideChange: true,
  fadeEffect: {
    crossFade: true,
  },
});
coSwiper3_1.on('slideChange', () => {
  coSwiper3_2.slideToLoop(coSwiper3_1.realIndex);
});

// ===================================================== ===================================================== GSAP
gsap.registerPlugin(ScrollTrigger);
let coHomeDur = 1;
let coHomeEase = "Power1.out";
let coHomeColor1 = "#f5f6f7";
let coHomeColor2 = "#C9C9C9";
let coHomeColor3 = "#f5f6f7";
// 1
ScrollTrigger.create({
  // markers: true,
  start: "-20% 0%",
  end: "-20% 0%",
  trigger: ".co-home-s2",
  onEnter: () => { gsap.to('body', { backgroundColor: coHomeColor2, duration: coHomeDur, ease: coHomeEase }); },
  onLeave: () => { },
  onEnterBack: () => { gsap.to('body', { backgroundColor: coHomeColor1, duration: coHomeDur, ease: coHomeEase }); },
  onLeaveBack: () => { }
});
// 2
ScrollTrigger.create({
  // markers: true,
  start: "-20% 0%",
  end: "-20% 0%",
  trigger: ".co-home-s3",
  onEnter: () => { gsap.to('body', { backgroundColor: coHomeColor3, duration: coHomeDur, ease: coHomeEase }); },
  onLeave: () => {},
  onEnterBack: () => { gsap.to('body', { backgroundColor: coHomeColor2, duration: coHomeDur, ease: coHomeEase }); },
  onLeaveBack: () => {}
});
// 3
ScrollTrigger.create({
  // markers: true,
  start: "-20% 0%",
  end: "-20% 0%",
  trigger: ".co-home-s5",
  onEnter: () => { gsap.to('body', { backgroundColor: coHomeColor2, duration: coHomeDur, ease: coHomeEase }); },
  onLeave: () => {},
  onEnterBack: () => { gsap.to('body', { backgroundColor: coHomeColor3, duration: coHomeDur, ease: coHomeEase }); },
  onLeaveBack: () => {}
});
// 4
ScrollTrigger.create({
  // markers: true,
  start: "-20% 0%",
  end: "-20% 0%",
  trigger: ".co-home-s7",
  onEnter: () => { gsap.to('body', { backgroundColor: coHomeColor3, duration: coHomeDur, ease: coHomeEase }); },
  onLeave: () => {},
  onEnterBack: () => { gsap.to('body', { backgroundColor: coHomeColor2, duration: coHomeDur, ease: coHomeEase }); },
  onLeaveBack: () => {}
});









